import { cn as t } from "../../../lib/utils.es.js";
import { spinnerVariants as e } from "./Spinner.variants.es.js";
import { jsx as m } from "react/jsx-runtime";
import { LoaderCircleIcon as n } from "lucide-react";
var d = ({ className: o, size: a, "aria-hidden": r, ...i }) => /* @__PURE__ */ m(n, {
  "aria-hidden": r,
  "aria-label": r ? void 0 : "Загрузка",
  className: t(e({ size: a }), o),
  "data-slot": "spinner",
  role: r ? void 0 : "status",
  ...i
});
export {
  d as Spinner
};
